import React from 'react';
import {Button, Form, Input, NavBar, TextArea} from "antd-mobile";
import {useNavigate} from "react-router-dom";
import {addSecret} from "../../services/secret";
import response from "../../utils/response";

import './add.css';

const SecretAdd = () => {
    const navigate = useNavigate();

    function handleGoBack() {
        navigate(-1);
    }

    const onFinish = (values) => {
        addSecret(values).then(res => {
            let {code} = res || {};

            if (response.isSuccess(code)) {
                handleGoBack();
            }
        });
    };

    return (
        <div className="page-container">
            <div className="page-top">
                <NavBar
                    onBack={handleGoBack}
                >
                    添加
                </NavBar>
            </div>
            <div className="page-body">
                <Form
                    name='form'
                    onFinish={onFinish}
                    footer={
                        <Button block type='submit' color='primary' size='large'>
                            提交
                        </Button>
                    }
                >
                    <Form.Item name='title' label='标题' rules={[{ required: true }]}>
                        <Input placeholder='请输入标题' clearable={true} />
                    </Form.Item>
                    <Form.Item name='content' label='内容' rules={[{ required: true }]}>
                        <TextArea
                            placeholder='请输入内容'
                            showCount
                            autoSize={{ minRows: 3, maxRows: 10 }}
                        />
                    </Form.Item>
                </Form>
            </div>
        </div>
    )
};

export default SecretAdd;